import { useEffect, useState } from 'react';
import { latestReleases } from '../api/releases';
import type { ReleaseDto } from '../api/types';
import { formatSize } from '../lib/format';
import PublicPageLayout from './PublicPageLayout';

const PLATFORM: Record<string, { label: string; icon: string }> = {
  android: { label: 'Android', icon: '/device-phone.svg' },
  windows: { label: 'Windows', icon: '/device-desktop.svg' },
};

export default function PublicDownloadPage() {
  const [releases, setReleases] = useState<ReleaseDto[] | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    latestReleases().then((items) => {
      if (active) setReleases(items);
    }).catch(() => {
      if (active) setError(true);
    });
    return () => { active = false; };
  }, []);

  return (
    <PublicPageLayout path="/download" title="Скачать">
      <section className="public-hero">
        <h1>Скачать HomeChat</h1>
        <p className="public-lead">
          Приложение для телефона и компьютера. Достаточно установить один раз — дальше обновления
          приходят внутри приложения. Вход по логину и паролю, тот же аккаунт, что и в веб-версии.
        </p>
      </section>

      <section className="public-section" aria-label="Сборки приложений">
        {error && <p className="public-state" role="alert">Не удалось загрузить список приложений. Обновите страницу и попробуйте снова.</p>}
        {releases === null && !error && <p className="public-state" role="status">Загрузка списка приложений…</p>}
        {releases?.length === 0 && <p className="public-state">Сборки пока не опубликованы.</p>}

        {releases?.map((release) => {
          const platform = PLATFORM[release.platform] ?? { label: release.platform, icon: '/download.svg' };
          return (
            <article className="public-card public-download-card" key={release.id}>
              <div className="public-download-details">
                <h2>
                  <img src={platform.icon} alt="" width={22} height={22} />
                  {platform.label} <span>· {release.version}</span>
                </h2>
                <p className="public-download-meta">
                  {formatSize(release.sizeBytes)}
                  {release.createdAt ? ` · ${new Date(release.createdAt).toLocaleDateString('ru-RU')}` : ''}
                </p>
                {release.notes && <div className="public-download-notes">{release.notes}</div>}
              </div>
              <a className="public-button" href={release.url}>Скачать</a>
            </article>
          );
        })}
      </section>

      <section className="public-section">
        <h2>Обновления</h2>
        <p>
          Android может попросить разрешение на установку из браузера — это ожидаемо. Дальше новые
          версии приходят внутри приложения: «Настройки» → «О приложении» → «Проверить обновление».
          Переписки и медиа хранятся на сервере, при переустановке ничего не пропадёт.
        </p>
        <div className="public-actions">
          <a className="public-button ghost" href="/">Открыть веб-версию</a>
          <a className="public-button ghost" href="/info">Как всё устроено</a>
        </div>
      </section>
    </PublicPageLayout>
  );
}
